import { render, staticRenderFns } from "./mainbusinessPage2.vue?vue&type=template&id=cdc56f54&scoped=true&"
import script from "./mainbusinessPage2.vue?vue&type=script&lang=js&"
export * from "./mainbusinessPage2.vue?vue&type=script&lang=js&"
import style0 from "./mainbusinessPage2.vue?vue&type=style&index=0&id=cdc56f54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc56f54",
  null
  
)

export default component.exports